import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import swal from "sweetalert";
import { customerView, getCustomerReceiptData, payoutWithNovusAsync, transactionRegistration, updateCustomerReceiptData } from "../../../services/services";
import { decrypt } from "../../../utils/encodingdecoding";
import { starblazeMerchantId } from "../../../utils";

const Receipt = () => {
    const [loader, setLoader] = useState(false);
    const [receiptList, setReceiptList] = useState([]);
    let Id = decrypt(localStorage.getItem('Id'));

    useEffect(() => {
        getReceiptDetails();
    }, []);

    const getReceiptDetails = async () => {
        setLoader(true);
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const res = await getCustomerReceiptData(tempToken?.access_token);
        if (res.message === "Success") {
            setReceiptList(res?.data);
        }
        setLoader(false);
    };

    const onSubmit = async (receipt, status) => {
        const { updatedAt, _attachments, receiptData, _etag, _rid, _self, _ts, ...rest } = receipt
        setLoader(true)
        const body = {
            ...rest, other1: {
                ...rest.other1,
                status: status
            }, receiptData
        }
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const custRes = await customerView(tempToken?.access_token, receipt.customercode)
        const payoutBody = {
            customer: {
                mobile: custRes.customer.mobile ?? ""
            },
            points: receiptData?.[0]?.redeemPoint ?? "",
            amount: receiptData?.[0]?.redeemAmount
                ? receiptData[0].redeemAmount * 100
                : "",
            accountType: receiptData?.[0]?.upiId ? "vpa" : "bank_account",
            vpaAddress: receiptData?.[0]?.upiId ?? "",
            toAccountNumber: receiptData?.[0]?.bankDetails?.accountNumber ?? "",
            ifsc: receiptData?.[0]?.bankDetails?.ifscCode ?? "",
            holderName: receiptData?.[0]?.bankDetails?.nickname ?? "",
            paymentMode: receiptData?.[0]?.upiId ? "UPI" : "IMPS"   // ex.  IMPS,NEFT,UPI etc
        }
        const payoutRes = await payoutWithNovusAsync(tempToken?.access_token, payoutBody);
        if (payoutRes.message === "Request processed successfully.") {
            const res = await updateCustomerReceiptData(tempToken?.access_token, body)
            if (res.message === "Success") {
                await getReceiptDetails()
                swal({
                    position: "center",
                    icon: "success",
                    title: "Request processed successfully.",
                    showConfirmButton: false,
                    timer: 2000,
                });
            } else {
                swal({
                    position: "center",
                    icon: "error",
                    title: res.message,
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } else {
            swal({
                position: "center",
                icon: "error",
                title: payoutRes.message,
                showConfirmButton: false,
                timer: 2000,
            });
        }
        setLoader(false)
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div><div></div><div></div><div></div>
                        <div></div><div></div><div></div><div></div>
                    </div>
                </div>
            )}

            <Header name={`${Id === starblazeMerchantId ? "Retailer" : "Customer"} Request`} />

            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>{`${Id === starblazeMerchantId ? "Retailer" : "Customer"} Request Details`}</h4>
                            </div>
                        </div>

                        <div className="receipt__body">
                            {receiptList?.length ? receiptList?.map((receipt, i) => {
                                const rdata = receipt?.receiptData?.[0];

                                const hasBank = rdata?.bankDetails && Object.keys(rdata.bankDetails).length > 0;
                                const hasUPI = rdata?.upiId;

                                const noPaymentInfo = !hasBank && !hasUPI;

                                return (
                                    <div key={i} className="receipt-box-wrapper">
                                        <div className="receipt-box">
                                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>

                                                <div>
                                                    {hasBank ? (
                                                        <>
                                                            <h6 className="fw-bold mb-2">Bank Details</h6>
                                                            <div className="lh-16">
                                                                {rdata?.bankDetails ? (
                                                                    <div>
                                                                        <p className="m-0"><strong>IFSC Code:</strong> {rdata?.bankDetails?.ifscCode || ""}</p>
                                                                        <p className="m-0"><strong>Bank Name:</strong> {rdata?.bankDetails?.bankName || ""}</p>
                                                                        <p className="m-0"><strong>Account Number:</strong> {rdata?.bankDetails?.accountNumber || ""}</p>
                                                                        <p className="m-0"><strong>Holder Name:</strong> {rdata?.bankDetails?.nickname || ""}</p>
                                                                    </div>
                                                                ) : null}

                                                            </div>
                                                        </>
                                                    ) : hasUPI ? (
                                                        <>
                                                            <h6 className="fw-bold mb-2">UPI Details</h6>
                                                            <p><strong>UPI ID:</strong> {rdata.upiId}</p>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <h6 className="fw-bold text-danger">Payment Details Missing</h6>
                                                            <p className="text-danger">
                                                                No bank or UPI information provided for payout.
                                                            </p>
                                                        </>
                                                    )}
                                                </div>

                                                <div>
                                                    <p className="m-0"><strong>Redeem Amount:</strong> {rdata?.redeemAmount || 0}</p>
                                                    <p className="m-0"><strong>Redeem Point:</strong> {rdata?.redeemPoint || 0}</p>

                                                    <div>
                                                        <strong>Status:</strong>{" "}
                                                        <span
                                                            className={`status-badge-patcorn ${receipt?.other1?.status === 0
                                                                ? "pending"
                                                                : receipt?.other1?.status === 1
                                                                    ? "accepted"
                                                                    : "rejected"
                                                                } ms-1`}
                                                        >
                                                            {receipt?.other1?.status === 0
                                                                ? " Pending"
                                                                : receipt?.other1?.status === 1
                                                                    ? " Accepted"
                                                                    : " Rejected"}
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>

                                            {receipt?.other1.status === 0 ? (
                                                <div
                                                    className="action-buttons d-flex justify-content-center gap-4"
                                                >
                                                    <button
                                                        className={`btn btn-success ${noPaymentInfo ? "opacity-50" : "opacity-100"}`}
                                                        disabled={noPaymentInfo}

                                                        onClick={() => !noPaymentInfo && onSubmit(receipt, 1)}
                                                    >
                                                        ✅ Accept
                                                    </button>

                                                    <button className="btn btn-danger" onClick={() => onSubmit(receipt, 2)}>
                                                        ❌ Reject
                                                    </button>
                                                </div>
                                            ) : null}

                                        </div>
                                    </div>
                                );
                            }) : (
                                <div className="no-data">No record found</div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Receipt;
